export class ClusterMapLayoutCalculationError extends Error {}
